import { EditableQuestion } from '../../components/Questionnaires/types';

export interface State {
  editedQuestionId: string | null;
  questions: EditableQuestion[];
  initialQuestions: EditableQuestion[];
  blockingAnswers: string[];
  currentSection: number; // Track which section we're adding questions to
}

export enum ActionTypes {
  SET_EDITED_QUESTION_ID = 'questionnaire/SET_EDITED_QUESTION_ID',
  SET_QUESTIONS = 'questionnaire/SET_QUESTIONS',
  ADD_EMPTY_QUESTION = 'questionnaire/ADD_EMPTY_QUESTION',
  SET_INITIAL_QUESTIONS = 'questionnaire/SET_INITIAL_QUESTIONS',
  SET_BLOCKING_ANSWERS = 'questionnaire/SET_BLOCKING_ANSWERS',
  ADD_BLOCKING_ANSWER = 'questionnaire/ADD_BLOCKING_ANSWER',
  REMOVE_BLOCKING_ANSWER = 'questionnaire/REMOVE_BLOCKING_ANSWER',
  SET_CURRENT_SECTION = 'questionnaire/SET_CURRENT_SECTION',
  ADD_EMPTY_QUESTION_TO_SECTION = 'questionnaire/ADD_EMPTY_QUESTION_TO_SECTION',
}
